import type { ProgramTerms } from '../shared';

export const trulicityTerms: ProgramTerms = {
    'self-pay': null,
    insurance: null,
};
